import { render, staticRenderFns } from "./ProjectConnectionDetails.vue?vue&type=template&id=d6c43a1e&scoped=true&"
import script from "./ProjectConnectionDetails.vue?vue&type=script&lang=js&"
export * from "./ProjectConnectionDetails.vue?vue&type=script&lang=js&"
import style0 from "./ProjectConnectionDetails.vue?vue&type=style&index=0&id=d6c43a1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6c43a1e",
  null
  
)

export default component.exports